export const environment = {
  name: 'Staging',
  env: 'backstage',
  appName: 'evsStudent',
  database: 'evs',
  version: require('../../package.json').version,
  apiVersion: '1',
  apiOptiVersion: '2',
  cmsBase: 'https://staging-front.envoituresimone.com',
  cdrBase: 'https://api-dev.envoituresimone.com/api',
  legacyBase: 'https://legacy-dev.envoituresimone.com',
  appBase: '',
  token_auth_config: {
    apiBase: 'https://api-dev.envoituresimone.com/api',
    secondaryApiBase: 'https://api-dev.envoituresimone.com/api',
    oAuthBase: 'https://api-dev.envoituresimone.com/api'
  },
  ionic: {
    appId: 'e6a4b2b8'
  },
  nbMaxFaultAllowed: 5,
  screenHeightLimit: 400,
  screenWidthLimit: 600,
  zendesk: {
    zendeskUrl: 'https://envoituresimone.zendesk.com/api/v2',
    zendeskMessagingWidgetKey: '18ef78c0-f425-4fee-a2bb-d0270aafab6a'
  },
  evsSecretApi: 'd6f28d7de0980e859086541f357f9d22000745ecd0f531b348bcf9e3e4165ae7',
  logsUrl: 'https://dev.envoituresimone.com/api/v1/log',
  sentryAddr: 'https://537215d521364f86908bc230baa8d353@sentry.io/1280189',
  apiMaxRetry: 3,
  iosAppId: '1448880045',
  packageName: 'com.envoituresimone.app',
  androidMarketId: null,
  usesUntilPrompt: 5,
  minRandomLimit: 1,
  maxRandomLimit: 3,
  footerNavLink: 'dashboard',
  dbVersion: 14,
  evsServices: [
    { name: 'cdr-service', protocol: 'https', hostname: 'cdr.envoituresimone.com', urlBase: '/api/v1' }
  ],
  minGoodAnswers: 35,
  gtmId: 'GTM-MKKWBP',
  firebaseConfig: {
    apiKey: 'AIzaSyCdCIuuucf5i4pIij4u3ej2CS87WBysijk',
    authDomain: 'stellar-sunrise-92815.firebaseapp.com',
    databaseURL: 'https://stellar-sunrise-92815.firebaseio.com',
    projectId: 'stellar-sunrise-92815',
    storageBucket: 'stellar-sunrise-92815.appspot.com',
    messagingSenderId: '24457391814',
    appId: '1:24457391814:web:146673edc3492a94b571c7',
    measurementId: 'G-QBZ0GG6G90'
  },
  callCenterPhone: '01 73 14 81 52',
  checkout: {
    environment: 'sandbox',
    scriptUrl: 'https://checkout-web-components.checkout.com/index.js',
    publicKey: 'pk_sbox_3yh2jf5ow4lt4wgz3474zfcj7y7',
  },
  featureFlags: {
    payment_plan_eligible_banner: 'providers',
    multiple_ads_per_series: 'providers',
    checkout_payment_new_flow: 'providers'
  }
};
